import * as React from 'react';
import { Dimensions, StyleSheet, ScrollView, Animated } from 'react-native';
import { Spinner, Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Accordion, Card, CardItem, View } from 'native-base';
import { LineChart, Grid, YAxis, XAxis } from 'react-native-svg-charts';
import CalCalDataApi from '../../api/CalCalDataApi';
import downloader from '../../components/downloader';

const AnimatedCard = Animated.createAnimatedComponent(Card);

const _GBP = function (num, decimals = false) {
	const numDec = decimals ? 2 : 0;
	return num < 0 ? '-£' + (0 - num).toFixed(numDec) : '£' + Number(num).toFixed(numDec);
};

export default class ProfitLoss extends React.PureComponent {
	nScroll = new Animated.Value(0);
	headY = this.nScroll.interpolate({
		inputRange: [0, 200, 220],
		outputRange: [0, 0, 20]
	});

	constructor(props) {
		super(props);
		this.state = { loadingRpt: false };
	}
	componentWillMount() {}

	lineChart(weeklyData) {
		//const data = [50, 10, 40, 95, -4, -24, 85, 91, 35, 53, -53, 24, 50, -20, 50];
		const profit = weeklyData.map(p => Number(p.cumprofit));
		const labels = weeklyData.map(p => p.wkstart);
		const xAxisHeight = 35;
		const numTicks = weeklyData.length > 10 ? 10 : null;

		//console.log(labels);
		const verticalContentInset = { top: 2, bottom: 3, right: 0, left: 0 };
		return (
			<View style={{ height: 130, width: '100%', flexDirection: 'row' }}>
				<YAxis
					data={profit}
					contentInset={verticalContentInset}
					style={{ marginBottom: xAxisHeight }}
					svg={{
						fill: 'grey',
						fontSize: 8
					}}
					numberOfTicks={8}
					formatLabel={value => _GBP(value)}
				/>

				<View style={{ flex: 1, marginLeft: 10 }}>
					<LineChart style={{ flex: 1 }} contentInset={verticalContentInset} data={profit} svg={{ stroke: 'rgb(134, 65, 244)' }}>
						<Grid />
					</LineChart>

					<XAxis
						style={{ marginHorizontal: -10, height: xAxisHeight }}
						data={profit}
						numberOfTicks={numTicks}
						formatLabel={(v, index) => labels[index]}
						contentInset={{ left: 10, right: 10 }}
						svg={{
							fill: 'grey',
							fontSize: 8,
							fontWeight: 'bold',
							rotation: -45,
							originY: xAxisHeight,
							y: 8
						}}
					/>
				</View>
			</View>
		);
	}

	_renderHeader(item, expanded) {
		const { stuff } = item;
		return (
			<View style={{ flexDirection: 'row', padding: 5 }}>
				{expanded ? (
					<Icon style={{ fontSize: 18, alignSelf: 'center', marginRight: 10 }} name="arrow-dropup" />
				) : (
					<Icon style={{ fontSize: 18, alignSelf: 'center', marginRight: 10 }} name="arrow-dropdown" />
				)}
				<Left>
					<Text>{stuff.categoryName}</Text>
					{stuff.periodBudget && (
						<View style={{ width: '100%' }}>
							<View style={{ flexDirection: 'row' }}>
								<View style={{ flex: 1 }}>
									<Text note>Target:</Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text note style={{ textAlign: 'right' }}>
										{_GBP(stuff.periodBudget)}
									</Text>
								</View>
							</View>
							<View style={{ flexDirection: 'row' }}>
								<View style={{ flex: 1 }}>
									<Text note>Difference: </Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text note style={{ textAlign: 'right' }}>
										{_GBP(stuff.variance)}
									</Text>
								</View>
							</View>
						</View>
					)}
				</Left>
				<Right style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
					<Text note>Net </Text>
					<Text style={{ textAlign: 'right' }}> {_GBP(stuff.net)}</Text>
				</Right>
			</View>
		);
	}
	_renderDetails(item) {
		const i = item.stuff;
		return (
			<View style={{ flexDirection: 'row', margin: 10, marginRight: 30 }}>
				<View>
					<Left>
						<Text>
							{i.invs} Invoice
							{i.invs != 1 && 's'}
						</Text>
					</Left>
					<Body>
						<Text note>
							From {i.invcustomers} customer
							{i.invcustomers != 1 && 's'}
						</Text>
					</Body>
					<Right>
						<Text>{_GBP(i.invval)}</Text>
					</Right>
				</View>
				<View>
					<Left>
						<Text>
							{i.ninvs} Other Transaction
							{i.ninvs != 1 && 's'}
						</Text>
					</Left>
					<Body>
						<Text note>
							From {i.ninvcustomers} customer
							{i.ninvcustomers != 1 && 's'}
						</Text>
					</Body>
					<Right>
						<Text>{_GBP(i.ninvval)}</Text>
					</Right>
				</View>
			</View>
		);
	}
	inOutAccordion(totals) {
		const dataArray =
			totals &&
			totals.map(p => ({
				title: p.categoryName,
				stuff: p,
				content: `${p.net} ${p.payable}`
			}));

		return <Accordion style={{ borderWidth: 0, margin: 2, padding: 0 }} dataArray={dataArray} renderHeader={this._renderHeader} renderContent={this._renderDetails} />;
	}

	inOutCats(totals) {
		if (!totals) return <Text>No expenses this period</Text>;
		return (
			<List
				style={{ margin: 0 }}
				dataArray={totals}
				renderRow={(p, i) => (
					<ListItem noIndent key={i} style={{ margin: 0, padding: 0 }}>
						<Left>
							<Text>{p.categoryName}</Text>
						</Left>
						{p.periodBudget && (
							<Body style={{ paddingHorizontal: 20 }}>
								<View>
									<View style={{ flexDirection: 'row' }}>
										<View style={{ flex: 1 }}>
											<Text note>Target: </Text>
										</View>
										<View style={{ flex: 1 }}>
											<Text note style={{ textAlign: 'right' }}>
												{_GBP(p.periodBudget)}
											</Text>
										</View>
									</View>
									<View style={{ flexDirection: 'row' }}>
										<View style={{ flex: 1 }}>
											<Text note>Diff:</Text>
										</View>
										<View style={{ flex: 1 }}>
											<Text note style={{ textAlign: 'right' }}>
												{_GBP(p.variance)}
											</Text>
										</View>
									</View>
								</View>
							</Body>
						)}

						<Text style={{ textAlign: 'right' }}>{_GBP(p.net)}</Text>
					</ListItem>
				)}
			/>
		);
	}

	downloadLtd() {
		this.setState({ loadingRpt: true });
		CalCalDataApi.dataLoad('reports/ProfitLossLtd/' + this.props.filter.taxyear, this.props.jwt, res => {
			//console.log(res);
			if (res && !res.error) {
				this.setState({ loadingRpt: false });
				downloader(res.content, res.name);
			}
		});
	}

	render() {
		var { height, width } = Dimensions.get('window');
		const { reportData, filter } = this.props;
		__DEV__ && console.log('rendering profitLoss', reportData, filter);
		if (!reportData) return <Spinner style={{ flex: 1 }} />;
		//figure how many rows we can add
		return (
			<Body style={{ flex: 1, width: '100%' }} scrollable>
				{!!filter.taxyear && (
					<CardItem style={{ width: '100%', justifyContent: 'center' }}>
						<Button disabled={this.state.loadingRpt} onPress={() => this.downloadLtd()}>
							{this.state.loadingRpt ? <Spinner /> : <Text>{`Download your ${filter.taxyear}-${parseInt(filter.taxyear) + 1} company report`}</Text>}
						</Button>
					</CardItem>
				)}
				<Animated.ScrollView
					style={{ width: '95%' }}
					stickyHeaderIndices={[1, 3]}
					showsVerticalScrollIndicator={false}
					onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: this.nScroll } } }], { useNativeDriver: true })}>
					<Card>
						<CardItem header>
							<Text>Profit by week</Text>
						</CardItem>
						<CardItem>{reportData && reportData.profitByWeek && this.lineChart(reportData.profitByWeek)}</CardItem>
					</Card>
					<Animated.View style={styles.cardRoundTop}>
						<CardItem style={[styles.roundTopBlue, styles.green]}>
							<Left>
								<Text>Income</Text>
							</Left>
							<Right>
								<Text style={styles.moneyTxt}>+ £{reportData.takings}</Text>
							</Right>
						</CardItem>
					</Animated.View>
					{reportData && <CardItem style={styles.underCard}>{this.inOutAccordion(reportData.takingTotals)}</CardItem>}

					<Animated.View style={styles.cardRoundTop}>
						<CardItem style={[styles.roundTopBlue, styles.red]}>
							<Left>
								<Text>Expenses</Text>
							</Left>
							<Right>
								<Text style={styles.moneyTxt}>- £{reportData.expenses}</Text>
							</Right>
						</CardItem>
					</Animated.View>
					{reportData && <CardItem style={styles.underCard}>{this.inOutCats(reportData.expenseCatTotals)}</CardItem>}
				</Animated.ScrollView>
				<Card style={styles.cardRoundTop}>
					<CardItem header style={styles.roundTopBlue}>
						<Left>
							<Text>Profit</Text>
							<Text note style={{ color: '#0a6488' }}>
								Pre-tax
							</Text>
						</Left>
						<Right>
							<Text style={styles.moneyTxt}>= £{reportData.profit}</Text>
						</Right>
					</CardItem>
					{reportData.assetDep != 0 && (
						<CardItem>
							<Body>
								<Text style={{ fontSize: 12 }}>Minus Asset Depreciation</Text>
								<Text style={{ fontSize: 12 }}> (£ {reportData.assetDep})</Text>
							</Body>

							<Right>
								<Text style={{ fontWeight: 'bold', fontSize: 12 }}>= £{reportData.minusAssetDep}</Text>
							</Right>
						</CardItem>
					)}
				</Card>
			</Body>
		);
	}
}

const styles = StyleSheet.create({
	moneyTxt: {
		fontSize: 17,
		fontWeight: 'bold'
	},
	underCard: {
		alignSelf: 'center',
		backgroundColor: 'transparent',
		width: '95%',
		marginHorizontal: 10
	},
	cardRoundTop: {
		margin: 0,
		backgroundColor: 'transparent',
		//flex: 0,
		alignSelf: 'center',
		width: '95%',
		marginHorizontal: 20,
		flexDirection: 'column',
		borderRadius: 0, // Stupid Native Base workarounds
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},
	roundTopBlue: {
		width: '100%',
		backgroundColor: '#6aa4c8',
		borderRadius: 0,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},
	green: { backgroundColor: '#45c045' },
	red: { backgroundColor: '#c04545' }
});
